import { CSSProperties } from 'react'

export type Icons =
  | 'hide'
  | 'cross'
  | 'augmented-reality-cube'
  | 'checkmark'
  | 'chevron-left'
  | 'chevron-right'
  | 'single-star'
  | 'single-star-big'
  | 'single-star-big-partially-filled'
  | 'arrow-right'
  | 'arrow-left'
  | 'instagram'
  | 'youtube'
  | 'pinterest'
  | 'facebook'
  | 'cart'
  | 'account'
  | 'delivery-car'
  | 'return-circle'
  | 'mail'
  | 'heart'
  | 'plus'
  | 'cart-2'
  | 'sample-2'
  | 'error'
  | 'show-password'
  | 'hide-password'
  | 'sample-box-large'
  | 'sample-box-small'
  | 'filter-new'
  | 'search-icon'
  | 'bookmark'
  | 'hamburger'
  | 'logo-icon'
  | 'newsletter-promo'
  | 'user'
  | 'content-arrow-left-dark'
  | 'content-arrow-right-dark'
  | 'content-arrow-left-light'
  | 'content-arrow-right-light'
  | 'video-play'

export type Props = {
  name: Icons
  className?: string
  viewBox?: string
  setWidth?: number
  setHeight?: number
  style?: CSSProperties
  percent?: number
}

export const Icon = ({
  name,
  className = '',
  viewBox,
  setWidth,
  setHeight = setWidth,
  style,
  percent,
}: Props) => {
  const selectIcon = () => {
    switch (name) {
      case 'hide':
        return {
          width: 24,
          height: 24,
          icon: (
            <>
              <path
                d="M13.542 13.59c-.2.221-.44.398-.708.521a2.126 2.126 0 0 1-2.431-.464 2.256 2.256 0 0 1-.48-.748 2.313 2.313 0 0 1 .03-1.759 2.25 2.25 0 0 1 .505-.73m5.862 6.045A7.183 7.183 0 0 1 12 18c-5.09 0-8-6-8-6a13.734 13.734 0 0 1 3.68-4.455l8.64 8.91ZM10.473 6.18c.5-.12 1.013-.181 1.527-.18 5.09 0 8 6 8 6a13.91 13.91 0 0 1-1.57 2.393L10.472 6.18ZM4 4l16 16"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </>
          ),
        }
      case 'arrow-right':
        return {
          width: 24,
          height: 24,
          icon: (
            <>
              <title>Arrow Right</title>
              <desc>An arrow pointing right</desc>
              <path
                d="M3 12h18M15 18l6-6-6-6"
                stroke="currentColor"
                strokeWidth={1.3}
                strokeLinecap="round"
              />
            </>
          ),
        }
      case 'arrow-left':
        return {
          width: 24,
          height: 24,
          icon: (
            <>
              <title>Arrow Reft</title>
              <desc>An arrow pointing left</desc>
              <path
                d="M21 12H3M9 6l-6 6 6 6"
                stroke="currentColor"
                strokeWidth={1.3}
                strokeLinecap="round"
              />
            </>
          ),
        }
      case 'cross':
        return {
          width: 24,
          height: 24,
          icon: (
            <path
              d="M17.657 17.657 6.343 6.343M17.657 6.343 6.343 17.657"
              stroke="currentColor"
              strokeWidth={1.3}
              strokeLinecap="round"
            />
          ),
        }
      case 'augmented-reality-cube':
        return {
          width: 24,
          height: 24,
          icon: (
            <>
              <path
                d="M19.72 6.05a.497.497 0 0 1 .227.226l.008.015a.478.478 0 0 1 .045.22V10a.5.5 0 1 1-1 0V7.308l-2.276 1.138a.5.5 0 0 1-.448-.895L18.382 6.5l-2.106-1.053a.5.5 0 1 1 .448-.895l2.995 1.499ZM20 16.49a.506.506 0 0 1-.145.362.497.497 0 0 1-.136.097l-2.995 1.498a.5.5 0 0 1-.448-.894l2.106-1.053-2.106-1.053a.5.5 0 0 1 .448-.894l2.277 1.138V13A.5.5 0 1 1 20 13v3.489Zm-15.382.01 2.106 1.053a.5.5 0 0 1-.447.894L3.28 16.95a.497.497 0 0 1-.228-.225l-.007-.015-.014-.033A.52.52 0 0 1 3 16.49V13a.5.5 0 1 1 1 0v2.69l2.277-1.137a.5.5 0 1 1 .447.894L4.618 16.5ZM4 7.309V10a.5.5 0 0 1-1 0V6.51a.494.494 0 0 1 .281-.46l2.996-1.498a.5.5 0 0 1 .447.895L4.618 6.5l2.106 1.052a.5.5 0 0 1-.447.895L4 7.309Zm7.268-5.252a.496.496 0 0 1 .465 0l2.99 1.496a.5.5 0 1 1-.447.894L12 3.31V6a.5.5 0 1 1-1 0V3.31L8.724 4.447a.5.5 0 0 1-.448-.894l2.992-1.496Zm.465 18.886a.499.499 0 0 1-.465 0l-2.992-1.496a.5.5 0 0 1 .447-.894L11 19.69v-2.692a.5.5 0 0 1 1 0v2.692l2.276-1.138a.5.5 0 1 1 .447.894l-2.99 1.495ZM12 10.808v2.69a.5.5 0 1 1-1 0v-2.69L8.276 9.447a.5.5 0 0 1 .447-.895L11.5 9.941l2.776-1.389a.5.5 0 1 1 .447.895L12 10.809Z"
                fill="currentColor"
              />
            </>
          ),
        }
      case 'single-star':
        return {
          width: 16,
          height: 16,
          icon: (
            <>
              <path
                d="M8 0L9.79611 5.52786H15.6085L10.9062 8.94427L12.7023 14.4721L8 11.0557L3.29772 14.4721L5.09383 8.94427L0.391548 5.52786H6.20389L8 0Z"
                fill="currentColor"
              />
            </>
          ),
        }
      case 'single-star-big-partially-filled':
        return {
          width: 24,
          height: 22,
          icon: (
            <>
              <defs>
                <linearGradient id="percent" x1="0" y1="0" x2="1" y2="0">
                  <stop id="stop1" offset={`${percent || 0}%`} stopColor="black" />
                  <stop id="stop2" offset={`${percent || 0}%`} stopColor="lightgrey" />
                </linearGradient>
              </defs>
              <path
                d="M12 0L14.6942 8.2918H23.4127L16.3593 13.4164L19.0534 21.7082L12 16.5836L4.94658 21.7082L7.64074 13.4164L0.587322 8.2918H9.30583L12 0Z"
                fill="url(#percent)"
              />
            </>
          ),
        }
      case 'single-star-big':
        return {
          width: 24,
          height: 22,
          icon: (
            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.4062 6.00815e-05H0.5V15.3165H15.4062V6.00815e-05Z" fill="currentColor" />
              <path
                d="M7.953 10.3227L10.22 9.7323L11.1672 12.7318L7.953 10.3227ZM13.1702 6.44568H9.1797L7.953 2.58466L6.7264 6.44568H2.7358L5.9655 8.8389L4.7389 12.6999L7.9685 10.3067L9.956 8.8389L13.1702 6.44568Z"
                fill="white"
              />
            </svg>
          ),
        }
      case 'instagram':
        return {
          width: 34,
          height: 34,
          icon: (
            <>
              <path
                d="M17.377 22.8074C20.3761 22.8074 22.8074 20.3761 22.8074 17.377C22.8074 14.378 20.3761 11.9467 17.377 11.9467C14.378 11.9467 11.9467 14.378 11.9467 17.377C11.9467 20.3761 14.378 22.8074 17.377 22.8074Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M23.3504 4.8873H11.4037C7.80476 4.8873 4.88727 7.80479 4.88727 11.4037V23.3504C4.88727 26.9493 7.80476 29.8668 11.4037 29.8668H23.3504C26.9493 29.8668 29.8668 26.9493 29.8668 23.3504V11.4037C29.8668 7.80479 26.9493 4.8873 23.3504 4.8873Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M24.4365 11.6752C25.1863 11.6752 25.7941 11.0674 25.7941 10.3176C25.7941 9.56785 25.1863 8.96004 24.4365 8.96004C23.6867 8.96004 23.0789 9.56785 23.0789 10.3176C23.0789 11.0674 23.6867 11.6752 24.4365 11.6752Z"
                fill="black"
              />
            </>
          ),
        }
      case 'checkmark':
        return {
          width: 24,
          height: 24,
          icon: (
            <path
              d="m4 13 5 5L20 7"
              stroke="currentColor"
              strokeWidth={1.3}
              strokeLinecap="round"
            />
          ),
        }
      case 'chevron-left':
        return {
          width: 8,
          height: 14,
          icon: (
            <>
              <title>Chevron Left</title>
              <desc>A chevron pointing left</desc>
              <path
                d="M7 1L1 7L7 13"
                stroke="currentColor"
                strokeWidth={1.3}
                strokeLinecap="round"
              />
            </>
          ),
        }
      case 'chevron-right':
        return {
          width: 8,
          height: 14,
          icon: (
            <path
              d="M10 18L16 12L10 6"
              stroke="currentColor"
              strokeWidth="1.3"
              strokeLinecap="round"
            />
          ),
        }
      case 'plus':
        return {
          width: 24,
          height: 24,
          icon: (
            <>
              <title>Plus</title>
              <desc>A plus</desc>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.65 4a.65.65 0 1 0-1.3 0v7.35H4a.65.65 0 1 0 0 1.3h7.35V20a.65.65 0 1 0 1.3 0v-7.35H20a.65.65 0 1 0 0-1.3h-7.35V4Z"
                fill="currentColor"
              />
            </>
          ),
        }
      case 'youtube':
        return {
          width: 36,
          height: 35,
          icon: (
            <>
              <path
                d="M22.2818 17.3771L15.7654 13.0328V21.7213L22.2818 17.3771Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M3.81873 17.377C3.81873 21.4166 4.23607 23.7867 4.55332 25.0048C4.63813 25.3375 4.80099 25.6452 5.02841 25.9024C5.25583 26.1596 5.54126 26.3589 5.86106 26.4838C10.4058 28.2303 17.9376 28.1824 17.9376 28.1824C17.9376 28.1824 25.4692 28.2303 30.0141 26.4839C30.3339 26.359 30.6193 26.1596 30.8467 25.9024C31.0741 25.6452 31.237 25.3375 31.3218 25.0049C31.6391 23.7867 32.0564 21.4166 32.0564 17.377C32.0564 13.3375 31.6391 10.9674 31.3218 9.74925C31.237 9.41656 31.0742 9.10887 30.8467 8.85167C30.6193 8.59446 30.3339 8.39515 30.0141 8.27025C25.4693 6.52375 17.9376 6.57171 17.9376 6.57171C17.9376 6.57171 10.4059 6.52375 5.8611 8.27023C5.5413 8.39513 5.25587 8.59444 5.02844 8.85165C4.80102 9.10885 4.63816 9.41654 4.55335 9.74922C4.23608 10.9674 3.81873 13.3375 3.81873 17.377Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </>
          ),
        }
      case 'pinterest':
        return {
          width: 35,
          height: 35,
          icon: (
            <>
              <path
                d="M16.291 11.9467L11.9467 30.4098"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.35516 21.2534C7.41038 19.8441 6.8089 18.2331 6.59893 16.5495C6.38897 14.8659 6.57636 13.1565 7.14609 11.5583C7.71582 9.96015 8.65204 8.5177 9.8797 7.34658C11.1074 6.17546 12.5923 5.30824 14.2155 4.81444C15.8388 4.32064 17.5551 4.214 19.2269 4.50305C20.8988 4.79211 22.4797 5.46883 23.8429 6.47896C25.2061 7.48909 26.3137 8.80455 27.0769 10.3199C27.8401 11.8352 28.2376 13.5083 28.2377 15.2049C28.2377 21.2031 23.8934 24.9795 19.5492 24.9795C15.2049 24.9795 13.8974 22.1196 13.8974 22.1196"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </>
          ),
        }
      case 'facebook':
        return {
          width: 35,
          height: 35,
          icon: (
            <>
              <path
                d="M17.5 30.4098C24.6978 30.4098 30.5327 24.5749 30.5327 17.3771C30.5327 10.1792 24.6978 4.34427 17.5 4.34427C10.3021 4.34427 4.46716 10.1792 4.46716 17.3771C4.46716 24.5749 10.3021 30.4098 17.5 30.4098Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M22.9303 11.9469H20.7582C19.8941 11.9469 19.0653 12.2901 18.4543 12.9012C17.8433 13.5122 17.5 14.3409 17.5 15.2051V30.41"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13.1557 19.5493H21.8442"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </>
          ),
        }
      case 'cart':
        return {
          width: 25,
          height: 25,
          icon: (
            <>
              <path
                xmlns="http://www.w3.org/2000/svg"
                d="M4.50687 15.137L2.93611 10.6682C2.47888 9.36742 3.44412 8.005 4.82294 8.005H15.2924C16.6379 8.005 17.5996 9.30689 17.2041 10.5929L15.8296 15.0617C15.5715 15.901 14.7961 16.4738 13.918 16.4738H6.3937C5.5448 16.4738 4.78837 15.9379 4.50687 15.137Z"
                stroke="currentColor"
                strokeWidth="1.5"
              />
              <path
                xmlns="http://www.w3.org/2000/svg"
                d="M10.75 2C10.75 1.58579 10.4142 1.25 10 1.25C9.58579 1.25 9.25 1.58579 9.25 2L10.75 2ZM10.75 8L10.75 2L9.25 2L9.25 8L10.75 8Z"
                fill="currentColor"
              />
            </>
          ),
        }
      case 'cart-2':
        return {
          width: 20,
          height: 20,
          icon: (
            <>
              <path
                d="M4.50687 15.137L2.93611 10.6682C2.47888 9.36735 3.44412 8.00494 4.82294 8.00494H15.2924C16.6379 8.00494 17.5996 9.30683 17.2041 10.5929L15.8296 15.0617C15.5715 15.901 14.7961 16.4737 13.918 16.4737H6.3937C5.5448 16.4737 4.78837 15.9378 4.50687 15.137Z"
                stroke="currentColor"
                strokeWidth="1.5"
              />
              <path
                d="M10.5642 2.99992C10.5642 2.58571 10.2284 2.24992 9.81421 2.24992C9.4 2.24992 9.06421 2.58571 9.06421 2.99992L10.5642 2.99992ZM10.5642 7.61926L10.5642 2.99992L9.06421 2.99992L9.06421 7.61926L10.5642 7.61926Z"
                fill="currentColor"
              />
            </>
          ),
        }
      case 'sample-2':
        return {
          width: 20,
          height: 20,
          icon: (
            <>
              <path
                d="M10.2718 11.1366H4.9823V9.84195H10.2718V4.48926H11.6928V9.84195H16.9823V11.1366H11.6928V16.4893H10.2718V11.1366Z"
                fill="currentColor"
              />
            </>
          ),
        }
      case 'error':
        return {
          width: 18,
          height: 18,
          icon: (
            <>
              <path
                d="M9 7.3125V10.125"
                stroke="#CF3030"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.02638 2.81143L1.84055 13.4984C1.74157 13.6694 1.68937 13.8634 1.68921 14.061C1.68905 14.2586 1.74092 14.4528 1.83962 14.6239C1.93832 14.7951 2.08036 14.9372 2.25144 15.0361C2.42253 15.1349 2.61663 15.187 2.81421 15.187H15.1859C15.3835 15.187 15.5776 15.1349 15.7486 15.0361C15.9197 14.9372 16.0618 14.7951 16.1605 14.6239C16.2592 14.4528 16.311 14.2586 16.3109 14.061C16.3107 13.8634 16.2585 13.6694 16.1595 13.4984L9.9737 2.81143C9.87487 2.64069 9.7329 2.49895 9.562 2.40041C9.39111 2.30187 9.19731 2.25 9.00004 2.25C8.80277 2.25 8.60897 2.30187 8.43808 2.40041C8.26718 2.49895 8.12521 2.64069 8.02638 2.81143V2.81143Z"
                stroke="#CF3030"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9 13.5C9.46599 13.5 9.84375 13.1222 9.84375 12.6562C9.84375 12.1903 9.46599 11.8125 9 11.8125C8.53401 11.8125 8.15625 12.1903 8.15625 12.6562C8.15625 13.1222 8.53401 13.5 9 13.5Z"
                fill="#CF3030"
              />
            </>
          ),
        }
      case 'show-password':
        return {
          width: 18,
          height: 18,
          icon: (
            <>
              <path
                d="M9 3.93695C3.375 3.93695 1.125 9 1.125 9C1.125 9 3.375 14.062 9 14.062C14.625 14.062 16.875 9 16.875 9C16.875 9 14.625 3.93695 9 3.93695Z"
                stroke="currentColor"
                strokeOpacity="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9 11.8126C10.5533 11.8126 11.8125 10.5534 11.8125 9.00006C11.8125 7.44676 10.5533 6.18756 9 6.18756C7.4467 6.18756 6.1875 7.44676 6.1875 9.00006C6.1875 10.5534 7.4467 11.8126 9 11.8126Z"
                stroke="currentColor"
                strokeOpacity="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </>
          ),
        }
      case 'hide-password':
        return {
          width: 18,
          height: 18,
          icon: (
            <>
              <path
                d="M14.1433 8.95111L15.7471 11.729"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10.8408 10.4951L11.341 13.3317"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M7.15285 10.4937L6.65259 13.3308"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M3.85373 8.94885L2.24219 11.7401"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2.25 7.37402C3.43213 8.83726 5.59927 10.6875 9.00004 10.6875C12.4008 10.6875 14.5679 8.83727 15.7501 7.37404"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </>
          ),
        }
      case 'sample-box-small':
        return {
          width: 40,
          height: 33,
          icon: (
            <>
              <rect width="40" height="33" fill="white" />
              <path
                d="M20.0617 10.8076L32.5096 9.34923C33.2387 9.24506 33.9679 9.66173 34.2283 10.3388L35.895 14.2451C36.4158 15.443 35.7387 16.7971 34.4367 17.0576L26.1554 18.9846C25.1658 19.2451 24.1762 18.8284 23.5512 17.9951L20.0617 13.0471L16.52 17.9951C15.895 18.8284 14.9054 19.2451 13.9158 18.9846L5.63457 17.0576C4.33249 16.7971 3.6554 15.443 4.17624 14.2451L5.8429 10.3388C6.10332 9.66173 6.83249 9.24506 7.56165 9.34923L20.0617 10.8076ZM5.68665 14.8701C5.58249 15.1305 5.73874 15.3909 5.99915 15.443L14.2804 17.3701C14.5929 17.4742 14.9575 17.318 15.1658 17.0576L18.5512 12.318L7.35332 11.0159L5.68665 14.8701ZM24.9054 17.0576C25.1137 17.318 25.4783 17.4742 25.7908 17.3701L34.0721 15.443C34.3325 15.3909 34.4887 15.1305 34.3846 14.8701L32.7179 11.0159L21.52 12.318L24.9054 17.0576ZM31.7283 19.0888L33.395 18.6201V26.4846C33.395 27.6305 32.6137 28.6201 31.4679 28.9326L20.6346 31.6409C20.27 31.693 19.8533 31.693 19.4367 31.6409L8.60332 28.9326C7.45749 28.6201 6.72832 27.6305 6.72832 26.4846V18.6201L8.39499 19.0888V26.4846C8.39499 26.8492 8.60332 27.2138 9.01999 27.2659L19.2283 29.818V17.5784C19.2283 17.1617 19.5929 16.7451 20.0617 16.7451C20.4783 16.7451 20.895 17.1617 20.895 17.5784V29.818L31.0512 27.2659C31.4679 27.2138 31.7283 26.8492 31.7283 26.4846V19.0888Z"
                fill="#141414"
              />
            </>
          ),
        }
      case 'sample-box-large':
        return {
          width: 57,
          height: 47,
          icon: (
            <>
              <g clipPath="url(#clip0_1_2)">
                <path d="M57 0H0V47H57V0Z" fill="white" />
                <path
                  d="M28.5879 15.3926L46.3262 13.3156C47.3652 13.1672 48.4043 13.7606 48.7753 14.725L51.1504 20.2885C51.8925 21.9946 50.9276 23.9231 49.0723 24.2942L37.2714 27.0387C35.8613 27.4097 34.4511 26.8162 33.5605 25.6294L28.5879 18.5822L23.541 25.6294C22.6504 26.8162 21.2402 27.4097 19.83 27.0387L8.02926 24.2942C6.1738 23.9231 5.20894 21.9946 5.95114 20.2885L8.32613 14.725C8.69723 13.7606 9.7363 13.1672 10.7754 13.3156L28.5879 15.3926ZM8.10348 21.1786C7.95505 21.5495 8.1777 21.9204 8.54879 21.9946L20.3496 24.7392C20.7949 24.8875 21.3144 24.665 21.6113 24.2942L26.4355 17.5438L10.4785 15.6893L8.10348 21.1786ZM35.4902 24.2942C35.787 24.665 36.3066 24.8875 36.7519 24.7392L48.5527 21.9946C48.9238 21.9204 49.1464 21.5495 48.9981 21.1786L46.623 15.6893L30.666 17.5438L35.4902 24.2942ZM45.2128 27.1871L47.5879 26.5195V37.7205C47.5879 39.3525 46.4745 40.762 44.8418 41.207L29.4043 45.0643C28.8848 45.1385 28.291 45.1385 27.6973 45.0643L12.2597 41.207C10.6269 40.762 9.58786 39.3525 9.58786 37.7205V26.5195L11.9629 27.1871V37.7205C11.9629 38.2398 12.2597 38.759 12.8535 38.8332L27.4003 42.4681V25.0359C27.4003 24.4424 27.9199 23.8491 28.5879 23.8491C29.1816 23.8491 29.7754 24.4424 29.7754 25.0359V42.4681L44.248 38.8332C44.8418 38.759 45.2128 38.2398 45.2128 37.7205V27.1871Z"
                  fill="#141414"
                />
              </g>
              <defs>
                <clipPath id="clip0_1_2">
                  <rect width="57" height="47" fill="white" />
                </clipPath>
              </defs>
            </>
          ),
        }
      case 'filter-new':
        return {
          width: 18,
          height: 18,
          icon: (
            <>
              <path d="M1 1H13" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
              <path d="M2 5H12" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
              <path d="M3 9H11" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
            </>
          ),
        }
      case 'search-icon': {
        return {
          width: 16,
          height: 16,
          icon: (
            <>
              <script />
              <circle cx="7.5" cy="7.5" r="6.75" stroke="currentColor" strokeWidth="1.5" />
              <path
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                d="m11.97 13.636 3.03 3.03"
              />
            </>
          ),
        }
      }
      case 'bookmark': {
        return {
          width: 25,
          height: 25,
          icon: (
            <>
              <path
                d="m14.999 17.5-5-3.125-5 3.125V3.75a.625.625 0 0 1 .625-.625h8.75a.625.625 0 0 1 .625.625V17.5Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </>
          ),
        }
      }
      case 'cart': {
        return {
          width: 20,
          height: 20,
          icon: (
            <>
              <path
                d="m4.507 15.137-1.57-4.469a2 2 0 0 1 1.886-2.663h10.47a2 2 0 0 1 1.911 2.588l-1.374 4.469a2 2 0 0 1-1.912 1.412H6.394a2 2 0 0 1-1.887-1.337Z"
                stroke="currentColor"
                strokeWidth="1.5"
              />
              <path d="M10.75 2a.75.75 0 0 0-1.5 0h1.5Zm0 6V2h-1.5v6h1.5Z" fill="currentColor" />
            </>
          ),
        }
      }
      case 'hamburger': {
        return {
          width: 26,
          height: 10,
          icon: (
            <>
              <rect width="26" height="1.5" rx=".75" fill="currentColor" />
              <rect y="8.5" width="26" height="1.5" rx=".75" fill="currentColor" />
            </>
          ),
        }
      }
      case 'logo-icon': {
        return {
          width: 100,
          height: 25,
          icon: (
            <>
              <g clipPath="url(#clip0_5596_54014)">
                <mask
                  id="mask0_5596_54014"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="100"
                  height="25"
                >
                  <path d="M100 0H0V25H100V0Z" fill="white" />
                </mask>
                <g mask="url(#mask0_5596_54014)">
                  <path
                    d="M35.8875 16.9363C35.8875 16.9363 35.8875 15.8833 35.8875 15.8705C35.8875 10.7473 32.3875 6.79248 27.4624 6.79248C22.5749 6.79248 18.825 10.773 18.825 15.8963C18.825 21.058 22.5124 25 27.3999 25C31.1875 25 34.3875 22.6631 35.65 19.2604H32.0374C31.125 20.66 29.1624 21.7514 27.3875 21.7514C24.825 21.7 22.7875 19.607 22.3749 16.9363H35.8875ZM22.5875 13.9445C23.2875 11.6847 25.1875 10.0668 27.4875 10.0668C29.825 10.0668 31.6749 11.6847 32.3624 13.9445H22.5875Z"
                    fill="currentColor"
                  />
                  <path
                    d="M52.1749 13.187C52.0123 10.1438 50.3374 7.94811 47.5874 7.16485C46.7249 6.92089 45.6374 6.79248 44.8374 6.79248C44.0374 6.79248 42.9624 6.92089 42.0999 7.16485C39.3498 7.94811 37.6749 10.1566 37.5123 13.187C37.3999 15.4083 37.4624 23.3821 37.4624 24.4607H40.9249C40.9249 23.7288 40.9123 17.0262 40.9374 15.0103C40.9374 14.4839 40.9624 13.8033 41.1249 13.187C41.4123 12.057 41.9374 11.1967 42.9123 10.7088C43.3374 10.4905 43.6374 10.3878 44.2249 10.3107C44.6374 10.2594 45.0624 10.2594 45.4874 10.3107C46.0624 10.3878 46.3749 10.4905 46.7999 10.7088C47.7874 11.2096 48.3123 12.057 48.5874 13.187C48.7374 13.8161 48.7624 14.4967 48.7749 15.0103C48.7874 17.0262 48.7874 23.7288 48.7874 24.4607H52.2498C52.2249 23.3821 52.2874 15.4212 52.1749 13.187Z"
                    fill="currentColor"
                  />
                  <path
                    d="M8.8875 21.5332C5.95 21.5332 3.7125 19.0934 3.7125 15.9091C3.7125 12.6862 5.9625 10.2466 8.8875 10.2466C11.8625 10.2466 14.0625 12.6862 14.0625 15.9091C14.0625 19.0934 11.85 21.5332 8.8875 21.5332ZM8.72501 6.7925C6.7125 6.7925 4.8875 7.46019 3.425 8.60297V0H0C0 0 0 15.755 0 15.8706C0 21.0324 3.8375 24.9872 8.72501 24.9872C13.6501 24.9872 17.4875 21.0324 17.4875 15.8706C17.4875 10.7473 13.6501 6.7925 8.72501 6.7925Z"
                    fill="currentColor"
                  />
                  <path
                    d="M54.0374 18.5928C54.1999 21.6359 55.8749 23.8316 58.6249 24.6148C59.4874 24.8588 60.5749 24.9872 61.3749 24.9872C62.1749 24.9872 63.25 24.8588 64.1124 24.6148C66.8624 23.8316 68.5374 21.623 68.6999 18.5928C68.8124 16.3714 68.7499 8.39755 68.7499 7.31897H65.2874C65.2874 8.05086 65.2999 14.7534 65.2749 16.7694C65.2749 17.2959 65.25 17.9764 65.0874 18.5928C64.7999 19.7227 64.2749 20.583 63.2999 21.0709C62.8749 21.2891 62.5749 21.3919 61.9874 21.469C61.5749 21.5203 61.15 21.5203 60.7249 21.469C60.15 21.3919 59.8374 21.2891 59.4124 21.0709C58.4249 20.5701 57.8999 19.7227 57.6249 18.5928C57.4749 17.9635 57.45 17.283 57.4374 16.7694C57.4249 14.7534 57.4249 8.05086 57.4249 7.31897H53.9624C53.9874 8.39755 53.9124 16.3585 54.0374 18.5928Z"
                    fill="currentColor"
                  />
                  <path
                    d="M91.2375 21.5331C88.3 21.5331 86.0625 19.0806 86.0625 15.9091C86.0625 12.6862 88.3125 10.2466 91.2375 10.2466C94.2125 10.2466 96.4125 12.699 96.4125 15.9091C96.4125 19.0934 94.2 21.5331 91.2375 21.5331ZM100 15.8705C100 10.7473 96.1625 6.79248 91.2375 6.79248C86.35 6.79248 82.5125 10.7473 82.5125 15.8705C82.5125 21.0323 86.35 24.9872 91.2375 24.9872C93.2625 24.9872 95.1 24.3194 96.575 23.1638V24.4607H100V15.922C100 15.8962 100 15.8833 100 15.8705Z"
                    fill="currentColor"
                  />
                  <path
                    d="M83.1625 23.7031C82.1625 24.5121 80.6749 25 79.2875 25C77.9875 25 76.6875 24.6405 75.7374 23.9214C74.35 22.8814 73.6374 21.3663 73.6 19.4145C73.5625 17.3472 73.5749 10.4905 73.5749 10.4905H70.1499V7.30613H73.5374V2.04163H77.05V7.28046H82V10.4648H77.0875C77.0875 10.4648 77.0749 17.3729 77.0749 18.5799C77.0749 19.8382 77.4 20.6985 78.125 21.1865C78.9 21.7129 80.1625 21.7129 81.125 20.8912C81.325 21.3277 81.6 21.8414 81.9875 22.3806C82.4 22.9328 82.8124 23.3693 83.1625 23.7031Z"
                    fill="currentColor"
                  />
                </g>
              </g>
            </>
          ),
        }
      }
      case 'newsletter-promo': {
        return {
          width: 24,
          height: 24,
          icon: (
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.9521 0.698567C12.6576 -0.232856 11.3396 -0.232856 11.0451 0.698567L10.0469 3.85597C9.84173 4.50512 9.06194 4.76388 8.50935 4.36621L5.71154 2.3528C4.90805 1.77456 3.8428 2.59029 4.19154 3.51676L5.27664 6.39946C5.52641 7.06298 5.02549 7.76849 4.31672 7.75146L1.02606 7.67236C0.0169758 7.64811 -0.388479 8.96417 0.459306 9.51198L3.03561 11.1767C3.64531 11.5707 3.64531 12.4626 3.0356 12.8565L0.459306 14.5213C-0.38848 15.0691 0.0169733 16.3851 1.02606 16.3609L4.31672 16.2818C5.02549 16.2648 5.52641 16.9703 5.27664 17.6338L4.19154 20.5165C3.8428 21.443 4.90805 22.2587 5.71154 21.6804L8.50935 19.667C9.06194 19.2694 9.84173 19.5281 10.0469 20.1773L11.0451 23.3347C11.3396 24.2661 12.6576 24.2661 12.9521 23.3347L13.9503 20.1773C14.1555 19.5281 14.9353 19.2694 15.4879 19.667L18.2857 21.6804C19.0892 22.2587 20.1544 21.443 19.8057 20.5165L18.7206 17.6338C18.4708 16.9703 18.9717 16.2648 19.6805 16.2818L22.9712 16.3609C23.9802 16.3851 24.3857 15.0691 23.5379 14.5213L20.9616 12.8565C20.3519 12.4626 20.3519 11.5707 20.9616 11.1767L23.5379 9.51198C24.3857 8.96417 23.9802 7.64811 22.9712 7.67236L19.6805 7.75146C18.9717 7.76849 18.4708 7.06298 18.7206 6.39946L19.8057 3.51675C20.1544 2.59029 19.0892 1.77456 18.2857 2.35279L15.4879 4.36621C14.9353 4.76388 14.1555 4.50512 13.9503 3.85597L12.9521 0.698567ZM8.03019 9.95528C8.03019 11.1927 8.68612 11.8814 9.8668 11.8814C11.0475 11.8814 11.7034 11.1927 11.7034 9.95528V9.93288C11.7034 8.69545 11.0475 8.00674 9.8668 8.00674C8.68612 8.00674 8.03019 8.69545 8.03019 9.93288V9.95528ZM10.016 15.9633C10.1453 15.9633 10.2651 15.8951 10.3311 15.784L14.5527 8.67809C14.6979 8.43375 14.5218 8.12432 14.2376 8.12432C14.1082 8.12432 13.9885 8.19247 13.9224 8.30365L9.70086 15.4095C9.5557 15.6539 9.73179 15.9633 10.016 15.9633ZM10.9521 9.99447C10.9521 10.9016 10.5645 11.3999 9.8668 11.3999C9.16913 11.3999 8.78153 10.9016 8.78153 9.99447V9.89369C8.78153 8.98661 9.16913 8.48267 9.8668 8.48267C10.5645 8.48267 10.9521 8.98661 10.9521 9.89369V9.99447ZM12.5442 14.1547C12.5442 15.3922 13.2001 16.0809 14.3808 16.0809C15.5674 16.0809 16.2234 15.3922 16.2234 14.1547V14.1323C16.2234 12.8949 15.5674 12.2062 14.3808 12.2062C13.2001 12.2062 12.5442 12.8949 12.5442 14.1323V14.1547ZM15.472 14.1939C15.472 15.101 15.0844 15.5993 14.3808 15.5993C13.6831 15.5993 13.2955 15.101 13.2955 14.1939V14.0931C13.2955 13.1861 13.6831 12.6821 14.3808 12.6821C15.0844 12.6821 15.472 13.1861 15.472 14.0931V14.1939Z"
              fill="currentColor"
            />
          ),
        }
      }
      case 'user': {
        return {
          width: 25,
          height: 25,
          icon: (
            <>
              <path
                d="M10 12.5a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
              />
              <path
                d="M2.42 16.874a8.752 8.752 0 0 1 15.159 0"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </>
          ),
        }
      }
      case 'content-arrow-left-dark': {
        return {
          width: 54,
          height: 54,
          icon: (
            <>
              <g opacity="0.8" filter="url(#filter0_b_5139_39638)">
                <circle cx="27" cy="27" r="27" fill="white" fillOpacity="0.3" />
                <circle cx="27" cy="27" r="26.5" stroke="#8F8E8E" />
              </g>
              <path d="M31 19L24 26.5676L31 34" stroke="black" strokeWidth="2" />
              <defs>
                <filter
                  id="filter0_b_5139_39638"
                  x="-20"
                  y="-20"
                  width="94"
                  height="94"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feGaussianBlur in="BackgroundImageFix" stdDeviation="10" />
                  <feComposite
                    in2="SourceAlpha"
                    operator="in"
                    result="effect1_backgroundBlur_5139_39638"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_backgroundBlur_5139_39638"
                    result="shape"
                  />
                </filter>
              </defs>
            </>
          ),
        }
      }
      case 'content-arrow-right-dark': {
        return {
          width: 54,
          height: 54,
          icon: (
            <>
              <g opacity="0.8" filter="url(#filter0_b_5139_39632)">
                <circle cx="27" cy="27" r="27" fill="white" fillOpacity="0.3" />
                <circle cx="27" cy="27" r="26.5" stroke="#8F8E8E" />
              </g>
              <path d="M24 34L31 26.4324L24 19" stroke="black" strokeWidth="2" />
              <defs>
                <filter
                  id="filter0_b_5139_39632"
                  x="-20"
                  y="-20"
                  width="94"
                  height="94"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feGaussianBlur in="BackgroundImageFix" stdDeviation="10" />
                  <feComposite
                    in2="SourceAlpha"
                    operator="in"
                    result="effect1_backgroundBlur_5139_39632"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_backgroundBlur_5139_39632"
                    result="shape"
                  />
                </filter>
              </defs>
            </>
          ),
        }
      }
      case 'content-arrow-left-light': {
        return {
          width: 54,
          height: 54,
          icon: (
            <>
              <g opacity=".8" filter="url(#a)">
                <circle cx="27" cy="27" r="27" fill="#000" fillOpacity=".4" />
                <circle cx="27" cy="27" r="26.5" stroke="#fff" />
              </g>
              <path d="m31 19-7 7.568L31 34" stroke="#fff" strokeWidth="2" />
              <defs>
                <filter
                  id="a"
                  x="-30"
                  y="-30"
                  width="114"
                  height="114"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feGaussianBlur in="BackgroundImageFix" stdDeviation="15" />
                  <feComposite
                    in2="SourceAlpha"
                    operator="in"
                    result="effect1_backgroundBlur_5151_10582"
                  />
                  <feBlend
                    in="SourceGraphic"
                    in2="effect1_backgroundBlur_5151_10582"
                    result="shape"
                  />
                </filter>
              </defs>
            </>
          ),
        }
      }
      case 'content-arrow-right-light': {
        return {
          width: 54,
          height: 54,
          icon: (
            <>
              <g opacity=".8" filter="url(#a)">
                <circle cx="27" cy="27" r="27" fill="#000" fillOpacity=".4" />
                <circle cx="27" cy="27" r="26.5" stroke="#fff" />
              </g>
              <path d="m24 34 7-7.568L24 19" stroke="#fff" strokeWidth="2" />
              <defs>
                <filter
                  id="a"
                  x="-30"
                  y="-30"
                  width="114"
                  height="114"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feGaussianBlur in="BackgroundImageFix" stdDeviation="15" />
                  <feComposite
                    in2="SourceAlpha"
                    operator="in"
                    result="effect1_backgroundBlur_5151_10581"
                  />
                  <feBlend
                    in="SourceGraphic"
                    in2="effect1_backgroundBlur_5151_10581"
                    result="shape"
                  />
                </filter>
              </defs>
            </>
          ),
        }
      }
      case 'video-play': {
        return {
          width: 64,
          height: 64,
          icon: (
            <>
              <rect width="64" height="64" rx="32" fill="white" />
              <path d="M43.52 31.3601L26.24 41.3367L26.24 21.3835L43.52 31.3601Z" fill="#141414" />
            </>
          ),
        }
      }
      default:
        return { icon: null }
    }
  }

  const { icon, width, height } = selectIcon()
  if (!icon) return null
  return (
    <svg
      name={name}
      className={className}
      viewBox={viewBox ? viewBox : `0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      width={setWidth || width}
      height={setHeight || height}
      style={{ color: 'inherit', ...style }}
    >
      {icon}
    </svg>
  )
}
